const VocabUserSearchBar = {
  whitelist_tittle: ['Lista blanca', 'Whitelist'],
  network_username: ['Nombre de usuario', 'Username'],
  authorized_users: ['Usuarios autorizados', 'Authorized users'],
  authorize_user: ['Autorizar usuario', 'Authorize user'],
  search_user: ['Buscar usuario', 'Search user'],
  whitelist_empty: ['Ningún usuario con acceso', 'No user has access'],
  no_matches: [
    'Ningún usuario encontrado con ese nombre',
    'No user found under the provided username',
  ],
  impossible_to_search: ['Imposible realizar búsqueda', 'Impossible to search'],
  search_by_username_placeholder: [
    'Ejemplo: señor_doctor_123',
    'Example: mister_doctor_123',
  ],
  search_hint: [
    'Búsqueda por nombre de usuario',
    'Searches the network by username',
  ],
  searching: ['Buscando...', 'Searching...'],
};

export type VocabUserSearchBarFormKey = keyof typeof VocabUserSearchBar;
export default VocabUserSearchBar;

